var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import React, { Component } from 'react';
import { Translate } from "../../I18N";








const getUwaziFavorites = () =>
localStorage.getItem('uwaziFavorites') ? localStorage.getItem('uwaziFavorites').split(',') : [];

class FavoriteBanner extends Component {
  constructor(props) {
    super(props);
    this.state = { selected: false };
    this.toggleClick = this.toggleClick.bind(this);
  }

  componentDidMount() {
    const { sharedId } = this.props;
    const shouldBeSelected = getUwaziFavorites().includes(sharedId);
    if (shouldBeSelected) {
      this.setState({ selected: shouldBeSelected });
    }
  }

  toggleClick(e) {
    const { sharedId } = this.props;
    const uwaziFavorites = getUwaziFavorites();
    e.stopPropagation();
    e.preventDefault();
    if (uwaziFavorites.includes(sharedId)) {
      const itemIndex = uwaziFavorites.indexOf(sharedId);
      uwaziFavorites.splice(itemIndex, 1);
    } else {
      uwaziFavorites.push(sharedId);
    }
    localStorage.setItem('uwaziFavorites', uwaziFavorites.join(','));
    this.setState({ selected: getUwaziFavorites().includes(sharedId) });
  }

  render() {
    const { selected } = this.state;

    return /*#__PURE__*/(
      _jsx("button", {
        className: `btn favoriteBanner ${selected ? 'selected' : ''}`,
        onClick: this.toggleClick,
        type: "button",
        suppressHydrationWarning: true }, void 0, /*#__PURE__*/

      _jsx("span", { className: "tab-link-tooltip" }, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Add / remove favorite")
      )
      ));

  }
}

export { FavoriteBanner };